import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Menu, X, KeyRound, Unplug } from 'lucide-react'
import { useWbToken } from '../../hooks/useWbToken'

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [isTokenMenuOpen, setIsTokenMenuOpen] = useState(false)
  const { isConnected, disconnect } = useWbToken()
  const navigate = useNavigate()

  const handleDisconnect = () => {
    disconnect()
    navigate('/')
    setIsTokenMenuOpen(false)
  }

  const navigation = [
    { name: 'Дашборд', href: '/dashboard' },
    { name: 'История', href: '/history' },
  ]

  return (
    <header className="bg-white shadow-sm border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <button
              type="button"
              className="md:hidden p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              <span className="sr-only">Открыть меню</span>
              {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>

            <div className="flex-shrink-0 flex items-center">
              <Link to="/" className="flex items-center">
                <div className="h-8 w-8 rounded-lg bg-primary-600 flex items-center justify-center">
                  <span className="text-white font-bold text-sm">WB</span>
                </div>
                <span className="ml-2 text-xl font-bold text-gray-900">Greenlight</span>
              </Link>
            </div>

            <nav className="hidden md:ml-8 md:flex md:space-x-8">
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  className="inline-flex items-center px-1 pt-1 text-sm font-medium text-gray-900 border-b-2 border-transparent hover:border-primary-500 hover:text-primary-700"
                >
                  {item.name}
                </Link>
              ))}
            </nav>
          </div>

          <div className="flex items-center space-x-4">
            <div className="relative">
              <button
                type="button"
                className="flex items-center gap-2 px-3 py-2 rounded-full text-sm font-medium text-gray-700 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
                onClick={() => setIsTokenMenuOpen(!isTokenMenuOpen)}
              >
                <span className={`w-2.5 h-2.5 rounded-full ${isConnected ? 'bg-green-500' : 'bg-gray-400'}`} />
                <KeyRound className="h-4 w-4" />
                <span className="hidden md:inline">{isConnected ? 'Токен подключён' : 'Токен не подключён'}</span>
              </button>

              {isTokenMenuOpen && isConnected && (
                <>
                  <div
                    className="fixed inset-0 z-10"
                    onClick={() => setIsTokenMenuOpen(false)}
                  />
                  <div className="absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-20">
                    <div className="py-1">
                      <button
                        onClick={handleDisconnect}
                        className="flex w-full items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                      >
                        <Unplug className="mr-3 h-4 w-4" />
                        Отключить токен
                      </button>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Мобильное меню */}
      {isMenuOpen && (
        <div className="md:hidden border-t border-gray-200">
          <div className="px-2 pt-2 pb-3 space-y-1">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50"
                onClick={() => setIsMenuOpen(false)}
              >
                {item.name}
              </Link>
            ))}
          </div>
        </div>
      )}
    </header>
  )
}

export default Header
